import React, { useCallback } from 'react'
import { CopyOutlined } from '@ant-design/icons'
import { message } from 'antd'
import styled from 'styled-components'
import styles from './CopyText.module.css'

const StyledCopyText = styled.span`
  cursor: pointer;
`

export const CopyText: React.FC<{
  text: string
  successCallback?: () => void
  children?: React.ReactNode
  style?: React.CSSProperties
  dark?: boolean
}> = ({ text, style, children, successCallback, dark = true }) => {
  const [messageApi, contextHolder] = message.useMessage()
  const onCopy = useCallback(async () => {
    const result = await new Promise<boolean>((resolve, reject) => {
      try {
        const tempInput = document.createElement('input')
        tempInput.value = text
        document.body.appendChild(tempInput)
        tempInput.select()
        if (document.execCommand('copy')) {
          resolve(true)
        } else {
          reject(false)
        }
        tempInput.remove()
      } catch {
        reject(false)
      }
    })
    message.destroy()
    if (result) {
      successCallback?.()
      messageApi.open({
        type: 'success',
        content: '复制成功',
        className: dark ? '' : styles.customMessage,
      })
    } else {
      messageApi.open({
        type: 'error',
        content: '复制失败',
        className: dark ? '' : styles.customMessage,
      })
    }
  }, [text, successCallback])

  return (
    <>
      {contextHolder}
      <StyledCopyText onClick={onCopy} style={style}>
        {children ? (
          children
        ) : (
          <CopyOutlined
            style={{
              marginLeft: 8,
            }}
          />
        )}
      </StyledCopyText>
    </>
  )
}
